import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useState } from "react";
import axiosInstance from "../../../Axios";
import { toast } from "sonner";
import useAuth from "../../../contexts/UserContext.tsx";
import { BeatLoader } from "react-spinners";

export default function AddSchoolModal({
  open,
  setAddSchoolModalOpen,
  schoolTypes,
  districts,
  setReload,
}) {
  const [selectedSchoolType, setSelectedSchoolType] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [hmName, setHmName] = useState("");
  const [hmPhone, setHmPhone] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const clearStates = () => {
    setSelectedSchoolType("");
    setSelectedDistrict("");
    setSchoolName("");
    setHmName("");
    setHmPhone("");
    setAddress1("");
    setAddress2("");
  };

  const handleAddSchool = () => {
    console.log("Add School");
    if (selectedSchoolType === "") {
      toast.error("Please select school type");
      return;
    } else if (selectedDistrict === "") {
      toast.error("Please select district");
      return;
    } else if (schoolName === "") {
      toast.error("Please enter school name");
      return;
    } else if (hmName === "") {
      toast.error("Please enter HM name");
      return;
    } else if (hmPhone === "") {
      toast.error("Please enter HM phone");
      return;
    } else if (address1 === "") {
      toast.error("Please enter address 1");
      return;
    } else if (hmPhone.length !== 10) {
      toast.error("Please enter valid HM phone number");
      return;
    }
    setLoading(true);
    axiosInstance
      .post("/addSchool", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_type: selectedSchoolType,
        school_name: schoolName,
        dist_name: selectedDistrict,
        address1: address1,
        address2: address2,
        hm_name: hmName,
        hm_phone: hmPhone,
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setAddSchoolModalOpen(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        toast.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          clearStates();
          setAddSchoolModalOpen(false);
        }}
        fullWidth
      >
        <DialogTitle className="opacity-95">
          Add School
          <div className="text-sm opacity-60">Add a new school</div>
        </DialogTitle>
        <DialogContent
          sx={{ display: "flex", gap: 1, flexDirection: "column" }}
        >
          <FormControl size="small" sx={{ marginTop: "5px" }}>
            <InputLabel id="school_type">School Type</InputLabel>
            <Select
              labelId="school_type"
              variant="outlined"
              value={selectedSchoolType}
              onChange={(event) => setSelectedSchoolType(event.target.value)}
              label="School Type"
            >
              {schoolTypes.map((schoolType, index) => {
                return (
                  <MenuItem value={schoolType.value} key={index}>
                    {schoolType.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ marginTop: "5px" }}>
            <InputLabel id="dist_name">District</InputLabel>
            <Select
              labelId="dist_name"
              variant="outlined"
              value={selectedDistrict}
              onChange={(event) => setSelectedDistrict(event.target.value)}
              label="District"
            >
              {districts.map((district, index) => {
                return (
                  <MenuItem value={district.value} key={index}>
                    {district.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <TextField
            autoFocus
            margin="dense"
            id="school_name"
            label="School Name"
            variant="outlined"
            value={schoolName}
            onChange={(event) => setSchoolName(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="hm_name"
            label="HM Name"
            variant="outlined"
            value={hmName}
            onChange={(event) => setHmName(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="hm_phone"
            label="HM Phone"
            variant="outlined"
            value={hmPhone}
            onChange={(event) => setHmPhone(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="address1"
            label="Address 1"
            variant="outlined"
            value={address1}
            onChange={(event) => setAddress1(event.target.value)}
            size="small"
          />
          <TextField
            autoFocus
            margin="dense"
            id="address2"
            label="Address 2"
            variant="outlined"
            value={address2}
            onChange={(event) => setAddress2(event.target.value)}
            size="small"
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              clearStates();
              setAddSchoolModalOpen(false);
            }}
            color="error"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddSchool}
            disabled={loading}
          >
            {loading ? (
              <BeatLoader color="#3B82F6" size={6} className="py-2 px-3" />
            ) : (
              "Submit"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
